import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { defineChain, sepolia } from '@reown/appkit/networks';

// 1. Get projectId
const projectId = "74aff1cf96b559ec232cdfa646b4c403";

// 2. Set chains
// const defaultNetwork = {
//   chainId: 302,
//   name: 'zkCandy Sepolia Testnet',
//   currency: 'ETH',
//   explorerUrl: 'https://sepolia.explorer.zkcandy.io/',
//   rpcUrl: 'https://sepolia.rpc.zkcandy.io',
// };

// const zkcandyMainnet = defineChain({
//   chainId: 320,
//   name: 'ZKcandy Mainnet',
//   currency: 'ETH',
//   explorerUrl: 'https://explorer.zkcandy.io/',
//   rpcUrl: 'https://rpc.zkcandy.io',
// });

const zkcandyMainnet = /*#__PURE__*/ defineChain({
  id: 320,
  name: 'zkCandy Mainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Mainnet ETH',
    symbol: 'ETH',
  },
  rpcUrls: {
    default: { http: ['https://rpc.zkcandy.io'] },
  },
  blockExplorers: {
    default: {
      name: 'zkCandy Mainnet Explorer',
      url: 'https://explorer.zkcandy.io/',
    },
  },
  testnet: false,
})

// 3. Create a metadata object
const metadata = {
  name: 'zkCandy Points System',
  description: 'A point system to keep track users points',
  url: 'https://portal.zkcandy.io',
  icons: ['https://portal.zkcandy.io/favicon.ico'],
};

console.log("adapters: ", new EthersAdapter());
console.log("defaultNetwork: ", zkcandyMainnet);
console.log("metadata: ", metadata);
console.log("projectId: ", projectId);
// 4. Create a AppKit instance
const reown = createAppKit({
  adapters: [new EthersAdapter()],
  networks: [zkcandyMainnet],
  includeWalletIds: [
    "38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662"
  ],
  enableWalletConnect: false,
  metadata,
  projectId,
  features: {
    analytics: true, // Optional - defaults to your Cloud configuration
    socials: false,
    email: false,
  },
});
export default reown;
